import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import PassengerDesktopHeader from "./PassengerDesktopHeader";
import StepNavigationHeader from "../ItineraryHeader";


type Props = {
  navigateHandler?: () => void
}
function PassengerHeaderNavigation({ navigateHandler }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };

  return (
      isMobile ? (
          <StepNavigationHeader name="Passenger details" stepText="3 of 4" navigateHandler={handleNavigate} />
      ) : (
          <PassengerDesktopHeader navigateHandler={handleNavigate} />
      )
  )
}

PassengerHeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default PassengerHeaderNavigation;
